export { default as CheckSquareSolidIcon } from './CheckSquareSolidIcon';
